/* 自动生成入口 './build/bin/build-entry.js' */
// import ElementUI from 'element-ui'
import dayjs from 'dayjs'
import utils from '../packages/utils/utils.js'
import '../packages/styles/index.scss'

import kyChat from '../packages/chat/index.js'

const components = [
  kyChat
]

const install = function (app, opts = {}) {
  // 判断是否安装
  if (install.installed) return

  components.forEach(component => {
    app.component(component.name, component)
  })

  //   app.use(ElementUI)
  app.prototype.$dayjs = dayjs
  app.prototype.$chatUtils = utils
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

// 可按需引入
export {
  kyChat
}
// 可全部引入
export default {
  version: '0.0.3',
  // 全部注册
  install,
  // 按需引用
  kyChat
}
// 组件命名规范 k 或 ky 开头，如：KyLogin



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = null
// module chunks = 